import Users from "../components/configuration/users/Users";

const UsersPage = () => {
    return <Users />;
  };
  
  export default UsersPage;